<template>
  <div>
    <div class="imgArea">
      <video
        v-show="play"
        :height="imageHeight"
        :src="videoSrc"
        v-video="play"
        @ended="onEnded"
        autoplay
        muted
        playsinline />
      <img
        v-if="!play"
        :height="imageHeight"
        :src="imageSrc" />
    </div>
    <!-- モーメント再生ボタン -->
    <div class="playBtn" v-if="isMovie">
      <div v-if="videoError" class="disabled" @click="errorDialog = true" />
      <div v-else @click="play = !play" :class="{'playing': play}" />
    </div>
    <!-- プリクラ保存ボタン -->
    <normal-btn
      v-if="checkDownloadBtn()"
      @click="downloadPic(imageSrc, getImageName('purikura'))">
      プリクラをスマホに保存する
    </normal-btn>
    <div v-else class="caption">
      プリクラをスマホに保存するには、表示されている画像をタップして保存してください
    </div>
    <!-- モーメント保存ボタン -->
    <template v-if="isMovie">
      <template v-if="checkDownloadBtn()">
        <normal-btn v-if="videoError" class="error" @click="errorDialog = true">
          モーメントをスマホに保存する
        </normal-btn>
        <normal-btn
          v-else
          @click="downloadPic(videoSrc, getImageName('moment'))">
          モーメントをスマホに保存する
        </normal-btn>
      </template>
      <div v-else class="caption">
        モーメントをスマホに保存するには、iOS13以上にバージョンアップ、もしくはアプリ版のプリクラONをご利用ください
      </div>
    </template>
    <Dialog v-if="errorDialog">
      <div class="dialogText">
        <p>モーメントのデータ生成に失敗したため、この機能をご利用いただけません</p>
        <p>申し訳ございません</p>
      </div>
      <normal-btn @click="errorDialog = false">閉じる</normal-btn>
    </Dialog>
    <div class="dataArea">
      <div class="dateBox">
        <img class="logo" :src="getImg(logoUrl.arcadeLogoImg)">
        <div class="date">{{ date }}</div>
      </div>
      <div class="shopName">{{ shopName }}</div>
    </div>
    <sub-btn @click="onAlbum()">アルバムに戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from "../mixins/protobuf"
import NormalBtn from '../components/NormalBtn.vue'
import SubBtn from '../components/SubBtn.vue'
import Dialog from '../components/Dialog'
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const pbc = require('../assets/js/kumaproto').kuma.jp.protobuf.common
const { toJpegURI, toMP4URI, ymd, isIOS, getOSVersion } = require('../assets/js/util')

export default {
  name: "Detail",
  components: {
    NormalBtn,
    SubBtn,
    Dialog
  },
  mixins: [
    Protobuf
  ],
  directives: {
    video(el, binding){
      if (binding.value) {
        el.play()
        el.onended = () => el.currentTime = 0
      } else {
        el.pause()
        el.currentTime = 0
      }
    }
  },
  data() {
    return {
      arcadeName: '',
      date: '',
      image: null,
      imageSrc: '',
      play: false,
      shopName: '',
      video: '',
      videoSrc: '',
      videoError: false,
      isDelete: false,
      canDownload: false,
      errorDialog: false,
      isMovie: false,
      imageHeight: '450px',
      logoUrl: ''
    }
  },
  methods: {
    onEnded(event) {
      let el = event.target
      this.play = false
      el.load()
      el.autoplay = false
    },
    onDLVideo() {
      window.open(process.env.VUE_APP_INTRODUCTION_URL)
    },
    onDelete() {
      this.delete(this.$route.params.id)
    },
    delete(id) {
      const cmdNo = pb.AlbumPuriContentUpdateReq.CommandNo.COMMAND_NO
      const message = pb.AlbumPuriContentUpdateReq.create({
        actionType: pb.AlbumPuriContentUpdateReq.ActionType.DELETE,
        contentId: id
      })
      const encoded = pb.AlbumPuriContentUpdateReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.AlbumPuriContentUpdateResp.Status.SUCCESS) {
            this.$router.push('/puriContentDeleteFinish')
          } else {
            this.$_error('Error', { title: 'アルバム', statusCode: 432 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'アルバム', statusCode: 100 })
        })
    },
    /**
      モーションDLボタン表示チェック
     */
    checkDownloadBtn() {
      if (isIOS() && getOSVersion() < 13) {
        return false
      } else return true
    },
    getImageName(kind) {
      const t = new Date();
      const today = String(t.getFullYear()) + String(t.getMonth()+1) + String(t.getDate()) + String(t.getHours()) + String(t.getMinutes() + String(t.getSeconds()));
      if(kind === 'moment' ) {
        return 'moment_' + today + '.mp4';
      } else {
        return 'purikura_' + today + '.jpg';
      }
    },
    onAlbum() {
      this.$router.push('/album')
    },
    downloadPic(src, name) {
      let link = document.createElement('a');
      link.href = src;
      link.download = name;
      link.target = '_blank';
      link.click();
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
    async getArcadeLogo(name) {
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.logoUrl = decoded.masterArcadeList.find(item => item.name === name)
          this.isMovie = this.logoUrl.isMovie;
        })
    },
  },
  mounted() {
    this.getArcadeLogo(this.$route.params.arcadeName)
    const cmdNo = pb.PuriContentReq.CommandNo.COMMAND_NO
    const image = pbc.PuriContentType.FINAL_IMAGE
    const video = pbc.PuriContentType.FINAL_VIDEO
    const message = pb.PuriContentReq.create({
      id: this.$route.params.id,
      types: [image, video]
    })
    const encoded = pb.PuriContentReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        console.log('video', decoded.contents[video].length)
        if (decoded.status === pb.PuriContentResp.Status.SUCCESS) {
          this.image = decoded.contents[image]
          this.video = decoded.contents[video]
          this.videoSrc = toMP4URI(decoded.contents[video])
          this.imageSrc = toJpegURI(decoded.contents[image])
          decoded.contents[video].length ? this.videoError = false : this.videoError = true
        } else {
          this.$_error('Error', { title: 'アルバム', statusCode: 430 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'アルバム', statusCode: 100 })
      })
    this.shopName = this.$route.params.shopName
    this.arcadeName = this.$route.params.arcadeName
    this.date = ymd(this.$route.params.time).join('.')
    this.arcadeName === 'Bépiu.' || this.arcadeName === 'i my merry' || this.arcadeName === 'totolu' ? this.imageHeight = '375px' : this.imageHeight = '450px'
  }
}
</script>

<style lang="scss" scoped>
.imgArea { text-align: center; }
.playBtn {
  display: flex;
  justify-content: center;
  div {
    position: relative;
    width: 50px;
    height: 50px;
    margin-top: 20px;
    text-align:center;
    border-radius: 50%;
    background-color: #F63C5B;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 15px;
      left: 18px;
      width: 20px;
      height: 20px;
      border-left: 15px solid #fff;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid transparent;
    }
    &:active,
    &.playing { background-color: #F9607A; }
    &.disabled {
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: -2px;
        right: -2px;
        width: 20px;
        height: 20px;
        background-image: url(../assets/Png/Album/ic_album_detail_disabled.png);
        background-size: contain;
      }
    }
  }
}
.NormalBtn.error {
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: -2px;
    right: -2px;
    width: 20px;
    height: 20px;
    background-image: url(../assets/Png/Album/ic_album_detail_disabled.png);
    background-size: contain;
  }
}
.download {
  display: block;
  margin: 20px 30px 0;
  padding: 1.1em 0;
  font-size: 16px;
  color: #fff;
  width: 315px;
  text-align: center;
  background-color: #f63c5b;
  border-radius: 50px;
  cursor: pointer;
  transition: .3s;
  text-decoration: none;
  @media screen and (min-width:376px){
    &:hover:not(:disabled) { background-color: #FF7A91; }
    &:active:not(:disabled) { background-color: #F9607A; }
  }
}
.caption {
  margin: 40px 20px;
  padding: 30px 20px;
  border: 2px solid #F9B0BC;
  border-radius: 4px;
  box-shadow: inset 0 0 0 4px #fff, inset 0 0 0 5px #F9B0BC;
}
.dataArea {
  position: relative;
  margin: 30px 30px 0;
  padding: 20px 0 15px;
  text-align: center;
  border: 1px solid #8D7F81;
  border-radius: 2px;
  color: #373737;
  .dateBox {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -6px;
    left: 0;
    right: 0;
    font-size: 10px;
    .logo {
      width: auto;
      height: 15px;
      padding-left: 3px;
      background-color: #fbfcfd;
    }
    .date {
      padding: 0 3px;
      line-height: 15px;
      background-color: #fbfcfd;;
    }
  }
  .shopName { font-size: 12px; }
}
.dialog {
  .dialogText {
    font-size: 12px;
    color: #373737;
  }
  .NormalBtn { margin: 20px 0 0; }
}
.normala {
  outline: 1px solid red;
}
</style>
